import { createReducer } from 'angieslist-app-platform';
import { combineReducers } from 'redux';
import Immutable from 'immutable';
import appActionKeys from './appActionKeys';

export default (combineReducers({
  businessCenterPhone: createReducer(new Immutable.Map({ tel: '', text: '' }), {
    [appActionKeys.SET_BUSINESS_CENTER_PHONE]: (state, action) => action.payload,
  }),
}): any);



// WEBPACK FOOTER //
// ./src/app/common/appReducer.js